// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Myfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Montserrat", sans-serif;
  background-color: #f8f8f8;
  /* height: 100%;
	margin: 0;
	padding: 0;
	overflow-y: auto; */
}

@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("ttf");
  font-weight: 700;
}

/* font size manager */

h2,h3,h4{
  font-size: clamp(1rem, 2vw, 1.3rem);
  font-weight: 700;
  /* margin-bottom: 10px; */
}
button{
  font-size: clamp(0.7rem, 2vw, 1rem);
  font-weight: 600;
}
label, span{
  font-size: clamp(0.7rem, 2vw, 1rem);
  font-weight: 800;
}
P, textarea, input{
  font-size: clamp(0.8rem, 2vw, 1rem);
  font-weight: 500;
}

h1,h2, h3,h4, label, span, p, button, input, select, textarea {
  line-height: 1.2em;
  font-family: "Montserrat", sans-serif !important;
}
th, td{
  font-size: clamp(0.5rem, 2vw, 0.7rem);
  font-weight: 700;
}
select, input, textarea {
   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.icons{
  margin-right: 10px;
  color: #898989;
}

body {
  font-family: "Montserrat", sans-serif;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: auto;
}

.app {
  min-height: 100vh;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Sidebar overlay for mobile */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1299;
  display: block;
}

@media (min-width: 901px) {
  .sidebar-overlay {
    display: none;
  }
}

.mainPage {
  margin-left: 50px;
}
.main-content {
  margin: 20px 50px;
  max-width: 100%;
  box-sizing: border-box;
  /* overflow-x: hidden; */

  @media (max-width: 999px) {
    margin: 20px 20px;
  }

  @media (max-width: 640px) {
    margin: 15px 10px;
  }
}
/* .temporery{
  position: absolute;
  position-anchor: --actionbtn;

  left: calc(anchor(right) - 2%);
} */

.cancelBtn {
  padding: 10px 10px;
  border: none;
  border-radius: 30px;
  background-color: #a3a3a4db;
  color: #fff;
  cursor: pointer;
  width: max-content;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: clamp(0.8rem, 2vw, 1rem);    
  font-weight: 600;
}
.cancelBtn:hover {
  background-color: #7673739a;
  transform: scale3d(1.05, 1.05, 1);
}
.commonButton{
  background: #004996;
    color: #ffffff;
    padding: 10px 20px;
    border-radius: 30px;
    border: none;
    cursor: pointer; 
    font-size: clamp(0.8rem, 2vw, 1rem);
    display: flex;
    align-items: center;
    justify-content: center;
    /* margin-top: 20px; */
    transition: background 0.3s ease;
    width: fit-content;
  font-weight: 600;

}

.commonButton:hover{
  background: #003f7d;
  transform: scale3d(1.05, 1.05, 1);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,yBAAyB;EACzB;;;oBAGkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0DAAmD;EACnD,gBAAgB;AAClB;;AAEA,sBAAsB;;AAEtB;EACE,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;AACA;GACG,wCAAwC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,wBAAwB;;EAExB;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA;;;;;GAKG;;AAEH;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,mBAAmB;IACjB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,gCAAgC;IAChC,kBAAkB;EACpB,gBAAgB;;AAElB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC","sourcesContent":["body {\n  font-family: \"Montserrat\", sans-serif;\n  background-color: #f8f8f8;\n  /* height: 100%;\n\tmargin: 0;\n\tpadding: 0;\n\toverflow-y: auto; */\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"./assets/fonts/Myfont.ttf\") format(\"ttf\");\n  font-weight: 700;\n}\n\n/* font size manager */\n\nh2,h3,h4{\n  font-size: clamp(1rem, 2vw, 1.3rem);\n  font-weight: 700;\n  /* margin-bottom: 10px; */\n}\nbutton{\n  font-size: clamp(0.7rem, 2vw, 1rem);\n  font-weight: 600;\n}\nlabel, span{\n  font-size: clamp(0.7rem, 2vw, 1rem);\n  font-weight: 800;\n}\nP, textarea, input{\n  font-size: clamp(0.8rem, 2vw, 1rem);\n  font-weight: 500;\n}\n\nh1,h2, h3,h4, label, span, p, button, input, select, textarea {\n  line-height: 1.2em;\n  font-family: \"Montserrat\", sans-serif !important;\n}\nth, td{\n  font-size: clamp(0.5rem, 2vw, 0.7rem);\n  font-weight: 700;\n}\nselect, input, textarea {\n   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.icons{\n  margin-right: 10px;\n  color: #898989;\n}\n\nbody {\n  font-family: \"Montserrat\", sans-serif;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n}\n\n.app {\n  min-height: 100vh;\n}\n\n.app-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n/* Sidebar overlay for mobile */\n.sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1299;\n  display: block;\n}\n\n@media (min-width: 901px) {\n  .sidebar-overlay {\n    display: none;\n  }\n}\n\n.mainPage {\n  margin-left: 50px;\n}\n.main-content {\n  margin: 20px 50px;\n  max-width: 100%;\n  box-sizing: border-box;\n  /* overflow-x: hidden; */\n\n  @media (max-width: 999px) {\n    margin: 20px 20px;\n  }\n\n  @media (max-width: 640px) {\n    margin: 15px 10px;\n  }\n}\n/* .temporery{\n  position: absolute;\n  position-anchor: --actionbtn;\n\n  left: calc(anchor(right) - 2%);\n} */\n\n.cancelBtn {\n  padding: 10px 10px;\n  border: none;\n  border-radius: 30px;\n  background-color: #a3a3a4db;\n  color: #fff;\n  cursor: pointer;\n  width: max-content;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: clamp(0.8rem, 2vw, 1rem);    \n  font-weight: 600;\n}\n.cancelBtn:hover {\n  background-color: #7673739a;\n  transform: scale3d(1.05, 1.05, 1);\n}\n.commonButton{\n  background: #004996;\n    color: #ffffff;\n    padding: 10px 20px;\n    border-radius: 30px;\n    border: none;\n    cursor: pointer; \n    font-size: clamp(0.8rem, 2vw, 1rem);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* margin-top: 20px; */\n    transition: background 0.3s ease;\n    width: fit-content;\n  font-weight: 600;\n\n}\n\n.commonButton:hover{\n  background: #003f7d;\n  transform: scale3d(1.05, 1.05, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
